import { gql } from 'graphql.macro';

const adminInvoiceRefFields = gql`
    fragment adminInvoiceRefFields on AdminInvoiceRef {
        _id
        invoiceNumber
        type
        status
        invoiceDate
    }
`;

const adminInvoicePartyFields = gql`
    fragment adminInvoicePartyFields on AdminInvoiceParty {
        organizationId
        name
        invoiceName
        number
        customerNumber
        reference
        countryCode
        email
        address
    }
`;

export const adminInvoicesTemplate = gql`
    query adminInvoices($filters: AdminInvoiceFilters, $limit: Int, $offset: Int) {
        adminInvoices(filters: $filters, limit: $limit, offset: $offset) {
            total
            totalIsEstimate
            items {
                _id
                invoiceNumber
                type
                invoiceType
                status
                paymentStatus
                invoiceDate
                dueDate
                sentOn
                deliveryMethod
                total {
                    currency
                    totalIncVat
                }
                lab {
                    _id
                    name
                }
                customer {
                    organizationId
                    name
                }
                orderCount
            }
        }
    }
`;

export const adminInvoiceTemplate = gql`
    query adminInvoice($id: MongoDbObjectId!) {
        adminInvoice(id: $id) {
            _id
            invoiceNumber
            type
            invoiceType
            status
            paymentStatus
            invoiceDate
            dueDate
            sentOn
            deliveryMethod
            total {
                currency
                total
                vat
                totalIncVat
            }
            lab {
                _id
                name
                type
            }
            orderCount
            supplier {
                ...adminInvoicePartyFields
            }
            customer {
                ...adminInvoicePartyFields
            }
            createdOn
            createdBy {
                _id
                fullName
                email
            }
            dentist {
                _id
                fullName
                email
            }
            completedOn
            paidOn
            paymentTerm
            ocrNumber
            ourReference
            invoiceText
            costCenter
            gln
            processingErrorMessage
            lineItemCount
            lineItems {
                orderId
                articleNo
                description
                quantity
                itemPrice
                itemVatPercentage
                totalIncVat
            }
            orders {
                _id
                orderId
            }
            debitInvoice {
                ...adminInvoiceRefFields
            }
            creditInvoices {
                ...adminInvoiceRefFields
            }
            pdfs
        }
    }
    ${adminInvoicePartyFields}
    ${adminInvoiceRefFields}
`;

export const adminInvoicePdfUrlTemplate = gql`
    query adminInvoicePdfUrl($id: MongoDbObjectId!, $kind: AdminInvoicePdfKind!) {
        adminInvoicePdfUrl(id: $id, kind: $kind)
    }
`;
